// src/pages/AboutPage.js
import React from 'react';
import { Link } from 'react-router-dom';

function AboutPage() {
  return (
    <>
    <section className="hero-subpage about-hero">
        <div className="hero-content">
          <h1>About Ebamba Travel & Tours</h1>
          <p>Your journey with us is meticulously crafted for unforgettable moments.</p>
        </div>
    </section>

    <section className="about-section section-spacing">
      <div className="container">
        <h2>Our Commitment to Your Cape Town Adventure</h2>
        <p>Welcome to Ebamba Travel & Tours, your trusted partner for exploring the wonders of Cape Town and its magnificent surroundings. Founded with a passion for travel and a deep love for the Western Cape, we specialize in crafting unique and unforgettable journeys for every adventurer.</p>
        
        <h3>Private, Personalized Cape Town Tours</h3>
        <p>All our Cape Town tours are designed and tailored for your individual or group interests, ensuring every experience is an unforgettable one. Our itineraries feature general routes so you don’t miss the must-see places, and then you decide which extras you would like to add to your day. These extras can include activities like picnics, animal encounters, sunset sundowners, and many more. Speak to one of our expert agents to assist you in getting your itinerary just right.</p>

        <h3>Expert Local Knowledge & World-Class Refinement</h3>
        <p>Our team consists of experienced local guides who bring the history, culture, and natural beauty of the region to life. We pride ourselves on personalized service, attention to detail, and a commitment to ensuring your safety and enjoyment. We combine intimate local knowledge with world-class refinement, showcasing Cape Town in all its splendor and variety – from iconic landmarks to the best-kept secrets that few ever get to enjoy.</p>

        <h3>Luxury and Professionalism</h3>
        <p>Our commitment to you as a Cape Town tour operator is to ensure your Ebamba Cape Town tours are a safe, fun, and educational experience. While in the Mother City, we aspire to keep our service personal yet professional. If you really want to add that bit of elegance to your experience, we offer a wide variety of luxury vehicles to make our already luxurious experience even better, through our dedicated <Link to="/contact" style={{color: 'var(--primary-color)', fontWeight: 'bold'}}>Ebamba Chauffeur Service</Link>.</p>

        <h3>Explore with Ebamba</h3>
        <p>From the majestic Table Mountain to the pristine beaches of the Cape Peninsula, the lush vineyards of the Winelands, and thrilling safari experiences, we cover all the iconic destinations and hidden gems. Whether you're a first-time visitor or a seasoned traveler, we aim to provide an authentic and enriching experience that goes beyond the typical tourist path.</p>
        <p>Join us and discover why Cape Town is consistently voted one of the world's most beautiful cities. Let Ebamba Travel & Tours guide your next adventure!</p>
        <p><strong>Our Office:</strong> 207 Kings Road, Brooklyn, Cape Town</p>

        <div className="contact-links" style={{marginTop: '2rem'}}>
            <a href="https://wa.me/27736730809" className="btn btn-whatsapp" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-whatsapp"></i> Chat with Ebamba
            </a>
            <a href="tel:+27736730809" className="btn btn-call">
                <i className="fas fa-phone"></i> Call Ebamba Now
            </a>
        </div>
      </div>
    </section>
    </>
  );
}

export default AboutPage;
